import axios from "axios";
import Config from "../../config/config";

// GET /cadastro/filiais/lista devolve o documento inteiro das lojas ativas
// ({ error, data: [...] }). Diferente de lista-codigo-filiais, traz
// localidade/uf — é o que o filtro de filial por cidade precisa. Recorta aqui
// para o Redux não carregar config/seller/vendedores de cada loja.
const listaFiliais = () => {
    return axios({
        method: "get",
        url: `${Config.dev ? Config.api_dev : Config.api_prod}/api/v1/backoffice/cadastro/filiais/lista`
    }).then((res) => {
        const lista = Array.isArray(res.data?.data) ? res.data.data : [];
        return lista.map((f) => ({
            codigo_filial: f.codigo_filial,
            nome_exibicao: f.nome_exibicao,
            nome_fantasia: f.nome_fantasia,
            razao_social: f.razao_social,
            loja_ativa: f.loja_ativa,
            localidade: f.localidade,
            uf: f.uf
        }));
    });
};

export default listaFiliais;
